import { createConfirmation } from "react-confirm";
import AddNewUnitDialog from "./AddNewUnitDialog";

export const showAddNewUnitDialog = createConfirmation(AddNewUnitDialog);
